import {AnyImageOpResultNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {isImageOpHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-utils"
import {ImageOpSystem, REF_COUNT_DEBUG_ID_IMAGE_OP_SYSTEM_EVALUATE_RESULT} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-system"
import {computeLabStats} from "@app/textures/texture-editor/operator-stack/operators/recolor/helpers/lab-stats-subgraph"
import * as TextureEditNodes from "@app/textures/texture-editor/texture-edit-nodes"

// Computes the Lab-space mean/stddev of the recolor operator's own upstream sourceImage, the same
// way computeTargetStatsFromReferenceImage computes it for a reference image — used by
// OperatorRecolor.createImageOpGraph() on a sourceStatsCache miss (see operator-recolor.ts).
export async function computeSourceLabStats(
    imageOpSystem: ImageOpSystem,
    sourceImage: AnyImageOpResultNode,
): Promise<TextureEditNodes.OperatorRecolor["targetStats"]> {
    const evaluated = await imageOpSystem.evaluate("hal", sourceImage)
    try {
        const isGrayscale = evaluated.descriptor.channels === 1
        return await computeLabStats(imageOpSystem, evaluated, "linear", isGrayscale)
    } finally {
        if (isImageOpHal(evaluated)) {
            evaluated.release(REF_COUNT_DEBUG_ID_IMAGE_OP_SYSTEM_EVALUATE_RESULT)
        }
    }
}
